export default __webpack_public_path__ + "static/media/04_mlazina-min.d548375e.jpg";